// ** Root Slice & Helper Functions
import { baseApi } from './baseApi'
import { customErrorHandler } from './customErrorHandler'
import { TAGS } from './tags'

// ** Type Imports
import {
	type ClientLossLimitsResponse,
	type ClientLossLimitsVariables
} from '@/types'

/**
 * Read-only loss limit waterfall per company owner and this year's suspended
 * loss releases (`GET clients/:clientId/loss-limits?year=`). Never computed
 * in the browser.
 */
const lossLimitsApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		clientLossLimits: build.query<
			ClientLossLimitsResponse,
			ClientLossLimitsVariables
		>({
			query: ({ clientId, year }) => ({
				url: `/clients/${clientId}/loss-limits`,
				params: { year }
			}),
			transformErrorResponse: customErrorHandler,
			providesTags: (_, __, { clientId }) => [
				{ type: TAGS.LOSS_LIMITS, id: String(clientId) }
			]
		})
	})
})

export const { useClientLossLimitsQuery } = lossLimitsApi
